const FINANCE_STATIS = 'FINANCE_STATIS';

export function getLocalFinanceStatis(params) {
  return dispatch => {
    return dispatch({
      type: FINANCE_STATIS,
      data: params,
    });
  };
}

// Reducer
export function financeStatis(
  state = {
    checkedUUids: [],
    data: [],
    wid: 1000,
    scrollLeft: 0,
    scrollTop: 0,
    org: [],
    type: [],
  },
  action,
) {
  switch (action.type) {
    case FINANCE_STATIS:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finance_statis.js